module.exports = __webpack_public_path__ + "static/media/ic-support.a092159b.svg";